import './style/index.less';
import CustomCombo from './CustomCombo';

export default CustomCombo;
